import { render, staticRenderFns } from "./ques123.vue?vue&type=template&id=552a9d62"
import script from "./ques123.vue?vue&type=script&lang=js"
export * from "./ques123.vue?vue&type=script&lang=js"
import style0 from "./ques123.vue?vue&type=style&index=0&id=552a9d62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports